import { backendUrl } from '@shared/constants/urls/appUrls';
import { fetchWithAuth } from '@shared/utils/auth';

//Отправить запрос на пометку уведомлений как прочитанных
export const updateNotifications = async (notificationIds) => {
  const url = `${backendUrl}/api/notifications/`;
  const options = {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ notifications_ids: notificationIds }),
  };
  try {
    const response = await fetchWithAuth(url, options);
    if (!response.ok) {
      throw new Error(`Сетевая ошибка при обновлении уведомлений: HTTP error! Status: ${response.status}`);
    }
    return response;
  } catch (error) {
    console.error('Программная ошибка обновления уведомлений:', error);
    throw error;
  }
};